import { z } from "@hono/zod-openapi";
import { tmsEventKind } from "../base";
import { formSubmissionRefs } from "../subjects/formSubmission/refs";

/**
 * The driver reported freight over, short, or damaged.
 */
export const osdReportV1 = tmsEventKind(
  { category: "exception", kind: "osdReport", version: 1 },
  {
    refs: formSubmissionRefs,
    facts: {
      orderNumber: z.string().nullable(),
      overCount: z.number().nullable(),
      shortCount: z.number().nullable(),
      damagedCount: z.number().nullable(),
    },
  },
);

export const OsdReportV1Schema = osdReportV1.schema;
export const OsdReportV1FactsSchema = osdReportV1.facts;

export type OsdReportV1 = z.infer<typeof OsdReportV1Schema>;
export type OsdReportV1Facts = z.infer<typeof OsdReportV1FactsSchema>;

/** Every version of `osdReport`, keyed by version. What `catalog.ts` places under `exception`. */
export const osdReport = { 1: osdReportV1 } as const;
